<template>
  <section class="overlay absolute lg:fixed top-0 left-0 flex flex-col lg:flex-row w-full h-full mo:min-h-screen">
    <div class="overlay__close fixed text-brand">
      <button @click="onOverlayClose"><img src="@/assets/svg/close.svg" class="close-button" /></button>
    </div>
    <div class="w-full lg:h-full lg:overflow-y-auto lg:w-1/2 order-2 lg:flex flex-col justify-center items-center lg:order-none pt-16 mb-16 lg:pt-0">
      <template v-if="activeContentId < contentIDs.STAUDINGER">
        <div class="max-w-2xl p-6 md:p-12 lg:h-full w-full lg:flex flex-col justify-center items-center mx-auto">
          <div class="mo:hidden lg:h-full w-full lg:flex justify-center items-center">
            <img
              src="@/assets/svg/ccurl_gallery_logo.svg"
              class="overlay__logo md:mb-12"
              v-if="activeContentId === contentIDs.GALLERY " />
            <img
              src="@/assets/svg/ccurl_consulting_logo.svg"
              class="overlay__logo md:mb-12"
              v-if="activeContentId === contentIDs.CONSULTING" />
            <img
              src="@/assets/svg/ccurl_conversation_logo.svg"
              class="overlay__logo md:mb-12"
              v-if="activeContentId === contentIDs.CONVERSATION" />
            <img
              src="@/assets/svg/ccurl_gtn_logo.svg"
              class="overlay__logo md:mb-12"
              v-if="activeContentId === contentIDs.GTN" />
          </div>
          <div class="md:h-full w-full mo:pb-12">
            <div class="u-p text-left mx-auto max-w-lg" v-html="getContentBlock.copy"></div>
            <div class="text-center mt-24 md:mt-32">
              <a class="block u-p__sm--oblique" :href="getContentBlock.url" target="_blank">{{ getContentBlock.urlText }}</a>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="max-w-2xl w-full lg:h-full lg:flex flex-col justify-center items-center p-6 md:p-12">
          <h1 class="u-p uppercase text-brand mb-12 mx-auto max-w-lg">{{ getContentBlock.name }}</h1>
          <div class="u-p text-left text-brand mx-auto max-w-lg pb-12 lg:pb-0" v-html="getContentBlock.copy"></div>
          <div class="md:mt-12 max-w-lg justify-center text-center w-full flex mo:flex-col items-center md:items-end u-p--small mo:pb-12">
            <template v-if="activeContentId == contentIDs.STAUDINGER">
              <div>
                <p>Readmore on <a class="u-p__sm--bold" href="https://de.wikipedia.org/wiki/Dirk_Staudinger" target="_blank">Wikipedia</a></p>
                <a class="u-p__sm--bold" href="mailto:dirk.staudinger@circleculture.com">dirk.staudinger@circleculture.com</a>
              </div>
            </template>
            <template v-else>
              <div class="mo:order-2">
                <p>Readmore on <a class="u-p__sm--bold" href="https://de.wikipedia.org/wiki/Johann_Haehling_von_Lanzenauer" target="_blank">Wikipedia</a></p>
                <a class="u-p__sm--bold" href="mailto:j.vonhaehling@circleculture.com">j.vonhaehling@circleculture.com</a>
              </div>
            </template>
            <template v-if="activeContentId == contentIDs.LANZENAUER">
              <a href="https://artsandnaturesocial.club" target="_blank">
                <img src="@/assets/svg/ccurl_artsandsocial_logo.svg" class="mo:mb-8 md:ml-8 mo:order-1 overlay__logo--arts pb-2" />
              </a>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="w-full lg:w-1/2 order-1 lg:order-none">
      <div class="overlay__image relative overflow-hidden lg:aspect-ratio-square ">
        <picture>
          <source media="(min-width: 768px)" :srcset="getContentBlock.image">
          <img
            class="overlay__image-item w-full h-auto lg:w-auto lg:h-full lg:transform-left lg:absolute lg:top-0"
            :src="getContentBlock.mobileImage">
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import content from '../mixins/content'
import { mapState } from 'vuex'
import { CONTENT_IDS } from '@/util/enums'

export default {
  data() {
    return {
      isActive: false,
      contentIDs: CONTENT_IDS
    }
  },
  mixins: [content],
  computed: {
    ...mapState(['activeContentId']),
    getContentBlock() {
      if(this.activeContentId == CONTENT_IDS.STAUDINGER) {
        return this.c.members[0]
      } else if(this.activeContentId == CONTENT_IDS.LANZENAUER) {
        return this.c.members[1]
      }
      return this.c.companies[this.activeContentId]
    }
  },
  methods: {
    onOverlayClose() {
      this.$emit('overlay-close')
    }
  }
}
</script>

<style lang="stylus">
.overlay
  background white
  z-index 99

  .close-button
    width 32px
    height 32px

  &__logo
    width 170px
    margin 0 auto
    &--arts
      width 64px

  &__image
    @media screen and (min-width: 1024px)
      padding-bottom 100vh !important
  &__image-item
    @media screen and (min-width: 1024px)
      left 50%
      transform translateX(-50%)
      max-width none

  &__close {
    position absolute
    z-index 2
    top 2rem
    right 2rem
  }

</style>